import type { Toaster } from "@blueprintjs/core";

export const toaster: { current: Toaster | null } = {
  current: null,
};
